import dayjs from '~/libraries/dayjs';
var dayjsPlugin = function dayjsPlugin(_ref, inject) {
  var i18n = _ref.i18n;
  dayjs.locale(i18n.locale);
  inject('dayjs', dayjs);
};
export default dayjsPlugin;